export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

export const EMPTY_FILENAME = "empty-1eb00cab-e7e1-4d67-83c1-972d582168e6.png";
